// Story 8.2 (ADO-2011), AC4 — where focus goes after a cart line is removed, for
// every list of `CartLineRow`s (the side panel and /cart). A removal unmounts the
// focused control, so the host moves focus BEFORE that re-render: to the same
// control on the next row, else on the previous row, else to the host's heading.
// The Shopper keeps their place in the cart and never lands on <body>.
//
// Story 8.11 (ADO-2020): a neighbour can be another contributor's read-only row with
// no control at all, so a control-less next row falls through to the previous row
// before the heading.
import type { RowControl } from './CartLineRow';

/** Focus `control` on the row after (else before) the row for `skuCode` inside
 *  `list`, falling back to that row's first button; a neighbour with neither is
 *  skipped. `fallback` when no neighbour has a control (or the row is not in `list`). */
export function focusNeighbourRow(
  list: HTMLElement | null,
  skuCode: string,
  control: RowControl,
  fallback: () => void,
): void {
  const rows = list === null ? [] : Array.from(list.querySelectorAll<HTMLElement>('li[data-sku]'));
  const index = rows.findIndex((row) => row.dataset['sku'] === skuCode);
  const neighbours = index === -1 ? [] : [rows[index + 1], rows[index - 1]];
  const target = neighbours
    .map(
      (neighbour) =>
        neighbour?.querySelector<HTMLElement>(`[data-control="${control}"]`) ??
        neighbour?.querySelector<HTMLElement>('button'),
    )
    .find((candidate) => candidate != null);
  if (target) {
    target.focus();
    return;
  }
  fallback();
}
